import { z } from "zod";

export interface RecallFormValues {
  recall_reason: string;
  recall_comments: string;
}

// The legacy redux-form version had no validation at all, so an empty reason
// reached the API and threw. Both the reason and a comment are required.
export const createRecallSchema = (requiredMessage: string) =>
  z.object({
    recall_reason: z.string().min(1, requiredMessage),
    recall_comments: z.string().min(1, requiredMessage),
  });
